
export default function ReviewsHero() {
  return (
    <section className="py-16 px-6 lg:px-8 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto text-center">
        <h1 className="text-5xl font-bold mb-6" style={{ fontFamily: '"Libre Baskerville", serif' }}>
          Book Reviews
        </h1>
        <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
          In-depth reviews of Canadian literature, from emerging voices to established masters. 
          Discover your next great read through our curated collection of thoughtful literary criticism.
        </p>
      </div>
    </section>
  );
}
